export const RELATIONS = {
    OneToMany: 1, ManyToOne: 2, OneToOne: 3, ManyToMany: 4, One: 5, Many: 6
};
